"use strict";
/*!
 *
 *  balloon.ts
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = exports.Pickup = exports.Message = exports.Header = exports.Hero = void 0;
var object_fit_videos_1 = __importDefault(require("object-fit-videos"));
var isTop = $('body').is('.tp');
;
var Hero = /** @class */ (function () {
    function Hero() {
        var _this = this;
        this.$hero = $('#TopHero');
        this.$lead = $('#HeroLead');
        this.$sound = this.$hero.find('input[name="sound"]');
        this.video = document.getElementById('HeroVideo');
        this.src = util.viewport !== 'phone' ? '/jinji/assets/movie/hero.mp4' : '/jinji/assets/movie/hero_sp.mp4';
        if (isTop) {
            this.videoInit();
            this.soundInit();
            $('.tp-Hero_Movie_Btn').fancybox({
                animationDuration: 700,
                transitionDuration: 700,
                arrows: false,
                infobar: false,
                smallBtn: false,
                toolbar: true,
                buttons: ['close'],
                wheel: false,
                touch: false,
                beforeShow: function () {
                    _this.$sound.filter(function (i, elem) {
                        return $(elem).val() === 'off';
                    }).prop('checked', true);
                    $(_this.video).prop('muted', true);
                }
            });
        }
        ;
    }
    Hero.prototype.videoInit = function () {
        var _this = this;
        this.$lead.find('path').each(function (i, elem) {
            var len = elem.getTotalLength();
            elem.style.strokeDasharray = len.toString();
            elem.style.strokeDashoffset = len.toString();
        });
        this.video.addEventListener('canplaythrough', function () {
            _this.play();
        });
        this.video.src = this.src;
        this.video.load();
        (0, object_fit_videos_1.default)(document.getElementById('HeroVideo'));
    };
    Hero.prototype.soundInit = function () {
        var _this = this;
        this.$sound.on('change', function (e) {
            if ($(e.currentTarget).val() === 'on') {
                $(_this.video).prop('muted', false);
            }
            else {
                $(_this.video).prop('muted', true);
            }
            ;
        });
    };
    Hero.prototype.play = function () {
        var _this = this;
        this.$hero.addClass('-play');
        setTimeout(function () {
            _this.$lead.find('path').each(function (i, elem) {
                elem.style.strokeDashoffset = '0';
            });
            _this.video.play();
        }, 700);
    };
    return Hero;
}());
exports.Hero = Hero;
;
var Header = /** @class */ (function () {
    function Header() {
        this.$header = $('#Header');
        this.$page2top = $('#Page2Top');
        if (isTop) {
            this.setEvent();
        }
        ;
    }
    Header.prototype.setEvent = function () {
        var _this = this;
        $(window).on('scroll', function (e) {
            var _top = $(e.currentTarget).scrollTop();
            if (_this.$header.is('.-w') && _top <= 0) {
                _this.$header.removeClass('-w');
                _this.$page2top.removeClass('-visible');
            }
            ;
            if (!_this.$header.is('.-w') && _top > 0) {
                _this.$header.addClass('-w');
                _this.$page2top.addClass('-visible');
            }
            ;
        });
    };
    return Header;
}());
exports.Header = Header;
require("particles.js");
var Message = /** @class */ (function () {
    function Message() {
        this.option = {
            "particles": {
                "number": {
                    "value": 80,
                    "density": {
                        "enable": true,
                        "value_area": 800
                    }
                },
                "color": {
                    "value": "#ffffff"
                },
                "shape": {
                    "type": "circle",
                    "stroke": {
                        "width": 0,
                        "color": "#2589AD"
                    },
                    "polygon": {
                        "nb_sides": 5
                    },
                    "image": {
                        "src": "img/github.svg",
                        "width": 100,
                        "height": 100
                    }
                },
                "opacity": {
                    "value": 0.5,
                    "random": false,
                    "anim": {
                        "enable": false,
                        "speed": 1,
                        "opacity_min": 0.1,
                        "sync": false
                    }
                },
                "size": {
                    "value": 5,
                    "random": true,
                    "anim": {
                        "enable": false,
                        "speed": 1000,
                        "size_min": 0.1,
                        "sync": false
                    }
                },
                "line_linked": {
                    "enable": true,
                    "distance": 200,
                    "color": "#2589AD",
                    "opacity": 0.5,
                    "width": 1
                },
                "move": {
                    "enable": true,
                    "speed": 3,
                    "direction": "none",
                    "random": false,
                    "straight": false,
                    "out_mode": "out",
                    "attract": {
                        "enable": false,
                        "rotateX": 600,
                        "rotateY": 1200
                    }
                }
            },
            "interactivity": {
                "detect_on": "canvas",
                "events": {
                    "onhover": {
                        "enable": false,
                        "mode": "repulse"
                    },
                    "onclick": {
                        "enable": false,
                        "mode": "push"
                    },
                    "resize": true
                },
                "modes": {
                    "grab": {
                        "distance": 400,
                        "line_linked": {
                            "opacity": 1
                        }
                    },
                    "bubble": {
                        "distance": 400,
                        "size": 40,
                        "duration": 2,
                        "opacity": 8,
                        "speed": 3
                    },
                    "repulse": {
                        "distance": 200
                    },
                    "push": {
                        "particles_nb": 4
                    },
                    "remove": {
                        "particles_nb": 2
                    }
                }
            },
            "retina_detect": true,
            "config_demo": {
                "hide_card": false,
                "background_color": "#b61924",
                "background_image": "",
                "background_position": "50% 50%",
                "background_repeat": "no-repeat",
                "background_size": "cover"
            }
        };
        if (isTop) {
            particlesJS('TopMessage', this.option);
        }
        ;
    }
    return Message;
}());
exports.Message = Message;
var Pickup = /** @class */ (function () {
    function Pickup() {
        var _this = this;
        this.$elem = $('#Pickup');
        this.$wrapper = $('#PickupSlider');
        this.$slider = $('#PickupSliderMain');
        this.$arrows = $('#PickupSliderArrows');
        this.$basis = $('.tp-Contents_Grid_Left');
        this.start = 0;
        this.end = 0;
        if (isTop) {
            this.$slider.on('init', function () {
                _this.init();
            });
            this.$slider.slick({
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                autoplay: true,
                autoplaySpeed: 4000,
                appendArrows: this.$arrows,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
            this.setPosition();
            $(window).on('scroll', function (e) {
                if (_this.$wrapper.is('.-inited') && util.viewport !== 'phone' && util.viewport !== 'tablet') {
                    var st = $(e.currentTarget).scrollTop();
                    if (!_this.$elem.is('.-fixed') && !_this.$elem.is('.-bottom') && st > _this.start) {
                        _this.$elem.addClass('-fixed');
                    }
                    ;
                    if (_this.$elem.is('.-fixed') && st <= _this.start) {
                        _this.$elem.removeClass('-fixed');
                    }
                    ;
                    if (_this.$elem.is('.-fixed') && !_this.$elem.is('.-bottom') && st > _this.end) {
                        _this.$elem.removeClass('-fixed').addClass('-bottom');
                    }
                    ;
                    if (_this.$elem.is('.-bottom') && !_this.$elem.is('.-fixed') && st <= _this.end) {
                        _this.$elem.removeClass('-bottom').addClass('-fixed');
                    }
                    ;
                }
                ;
            }).on('resize', function () {
                _this.setPosition();
            }).on('load', function () {
                _this.setPosition();
            });
        }
        ;
    }
    Pickup.prototype.init = function () {
        this.$wrapper.addClass('-inited');
        this.setPosition();
    };
    Pickup.prototype.setPosition = function () {
        this.start = this.$basis.offset().top - $('#Header').height();
        this.end = this.start + this.$basis.height() - this.$elem.outerHeight();
    };
    return Pickup;
}());
exports.Pickup = Pickup;
var Card = /** @class */ (function () {
    function Card() {
        this.$item = $('.tp-Grid_Item');
        if (isTop) {
            this.setEvent();
        }
        ;
    }
    Card.prototype.setEvent = function () {
        var _this = this;
        this.$item.on('mouseenter', function (e) {
            if (!util.isTouchDevice) {
                _this.show(e.currentTarget);
            }
            ;
        }).on('mouseleave', function (e) {
            if (!util.isTouchDevice) {
                _this.hide(e.currentTarget);
            }
            ;
        }).on('click', function (e) {
            if (util.isTouchDevice) {
                if (!$(e.currentTarget).is('.-expanded')) {
                    if ($('.tp-Grid_Item.-expanded').length) {
                        _this.hide($('.tp-Grid_Item.-expanded')[0]);
                    }
                    ;
                    _this.show(e.currentTarget);
                }
                else {
                    _this.hide(e.currentTarget);
                }
                ;
            }
            ;
        });
    };
    Card.prototype.show = function (elem) {
        $(elem).addClass('-expanded');
        $(elem).find('.tp-Grid_Item_Body').stop(false, true).slideDown(500, 'easeOutQuart');
        var $row = $(elem).closest('.tp-Grid_Row');
        if ($row.is('.-col-3')) {
            $row.children('.tp-Grid_Item').filter(function (i, elem) {
                return !$(elem).is('.-expanded');
            }).addClass('-sm');
        }
        ;
    };
    Card.prototype.hide = function (elem) {
        $(elem).removeClass('-expanded');
        $(elem).find('.tp-Grid_Item_Body').stop(false, true).slideUp(500, 'easeOutQuart');
        $('.tp-Grid_Item').removeClass('-sm');
    };
    return Card;
}());
exports.Card = Card;
